



























































































































































import { Component, Mixins } from "vue-property-decorator";
import { CREDENTIALS, TYPES_OF_STORAGE } from "@/config/consts";
import { translate, translateSelectorItems } from "@/utils";
import FormValidator from "@/mixins/FormValidator";
import { TestModule } from "@/store/test.module";
import { AuthService } from "@/services/auth.service";
import { AuthModule } from "@/store/auth.module";

@Component({})
export default class AuthView extends Mixins(FormValidator) {
  showPassword: boolean = false;
  email: string = "";
  password: string = "";
  get edsCheckDisabled() {
    return TestModule.getCheckEdsDisabled;
  }

  EnterDisable: boolean = false;
  iin = "";
  bin = "";
  selectedCredential = "";
  get credentials() {
    return translateSelectorItems.call(this, CREDENTIALS);
  }

  get enter_types() {
    return AuthModule.enter_types;
  }
  set enter_types(val) {
    AuthModule.setEnter_types(val);
  }

  get links() {
    return [
      {
        title: this.$t("auth-view.manuals.video-inctruction.title"),
        href: this.$t("auth-view.manuals.video-inctruction.href"),
      },
      {
        title: this.$t("auth-view.manuals.get-eds.title"),
        href: this.$t("auth-view.manuals.get-eds.href"),
      },
      {
        title: this.$t("auth-view.manuals.pay-instruction.title"),
        type: "pay",
      },
      {
        title: this.$t("auth-view.manuals.sign-act-instruction.title"),
        type: "SignAct",
      },
    ];
  }

  public async clickInstr(link: any) {
    //this.$router.push("/PayInstruction");
    if (link.type == "pay") AuthModule.setShowInstruction(true);
    if (link.type == "SignAct") AuthModule.setShowInstructionSignAct(true);
  }

  public async openForgotPasswordPage() {
    this.$router.push("/ForgotPassword");
  }

  storageType = TYPES_OF_STORAGE[0].value;
  get storageTypes() {
    return translateSelectorItems.call(this, TYPES_OF_STORAGE);
  }

  formRef = "form";
  error: ApiMessageObject | null = null;
  get errorMessage() {
    return translate(this.error)?.name;
  }
  public async authenticate() {
    if (!this.validateForm()) return;
    this.EnterDisable = true;

    const { result } = await (this.edsCheckDisabled
      ? AuthService.authenticateTest(
          this.bin,
          this.iin,
          this.selectedCredential,
        )
      : AuthService.authenticate(this.storageType));
    if (typeof result != "boolean") {
      this.error = result;
      this.EnterDisable = false;
    } else if (result) {
      this.EnterDisable = false;
      this.$router.push({ name: "f-redirect" });
    }
  }

  public async authenticateEmail() {
    try {
      if (!this.validateForm()) return;
      this.EnterDisable = true;

      const { result } = await AuthService.signInEmail(
        this.bin,
        this.email,
        this.password,
      );

      if (typeof result != "boolean") {
        this.error = result;
        this.EnterDisable = false;
      } else if (result) {
        this.EnterDisable = false;
        this.$router.push({ name: "f-redirect" });
      }
    } finally {
      this.EnterDisable = false;
    }
  }
}
